import React from "react"
import { Link } from "gatsby"
import Carousel from "../../components/carousel"
import TextBlock from "../../components/textBlock"
import Section from "../../components/section"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import VideoBlock from "../../components/videoBlock"

import amazonConnect from "../../images/partners/amazon_connect/amazon-connect.svg"
import amazonPartner from "../../images/partners/amazon_connect/consulting-partner.png"

import satisfaction from "../../images/partners/amazon_connect/satisfaction.svg"
import agentSatisfaction from "../../images/partners/amazon_connect/agent_satisfaction.svg"
import saving from "../../images/partners/amazon_connect/saving.svg"

import poster from "../../images/partners/amazon_connect/poster.png"
import flag from "../../images/partners/amazon_connect/flag.png"
import firstLogo from "../../images/partners/amazon_connect/first.svg"

import differentiators from "../../images/partners/amazon_connect/ML_AC_differentiators.svg"
import peopleBg from "../../images/partners/amazon_connect/first.png"

import assistApp from "../../images/partners/amazon_connect/SA_AssistApp_Graphic.png"
import migrateScale from "../../images/partners/amazon_connect/migrate_scale.svg"
import integrationAutomation from "../../images/partners/amazon_connect/integration_automation.svg"
import integrateAutomate from "../../images/partners/amazon_connect/integrate-automate.png"

const carouselData = [
  {
    title: "Omnichannel Contact Centre, Amazon Connect",
    subtitle:
      "Amazon’s elastic cloud-based contact centre solution, used by over 70k Amazon service agents worldwide.",
    image: amazonConnect,
    partner: amazonPartner,
  },
]

const AmazonConnect = () => (
  <Layout>
    <SEO
      title="Mission Labs - Approved AWS & Amazon Connect Consulting Partner"
      description="Mission Labs is an approved AWS & Amazon Connect Consulting Partner, offering solution design, development and migration support. "
      keywords="digital customer experience, ai, artificial intelligence, natural language processing, amazon connect, amazon lex, amazon polly, omnichannel cloud, uk technology companies, cloud communications, cloud phone provider, manchester tech, tech startup, mobile technology, app development, software companies, tech startup manchester, tech company lancashire, manchester digital, circleloop, smartagent, aws partner"
      robots="index, follow"
      revisit_after="1 month"
    />
    <Carousel data={carouselData} />
    <TextBlock
      contrast
      title="<span>Reimagine your contact centre with</span> Amazon Connect."
    >
      <p>
        We are one of the first UK companies to embrace and then extend Amazon
        Connect back in 2017, and we’ve now successfully deployed or provided
        expertise on Amazon Connect for numerous businesses in both public and
        private sectors. Our team of Amazon Connect experts are able to help
        global organisations supercharge their contact centre through a
        combination of advanced products and services all built around Amazon
        Connect.
      </p>
    </TextBlock>

    <section className="section section--center inverse section-padding">
      <div className="centre">
        <h2>Why is Amazon Connect different?</h2>
        <hr />
        <img src={differentiators} alt="ML_AC_differentiators" />
      </div>
    </section>
    <VideoBlock
      video="https://circleloop-assets.s3-eu-west-1.amazonaws.com/Mission+Labs/ML+Amazon+Connect+Video.mp4"
      poster={poster}
    >
      <div>
        <div className="flex">
          <h2>Regions served.</h2>
          <img src={flag} alt="" />
        </div>
        <hr />
        <p>
          Mission Labs is based in the United Kingdom and operates across
          Europe. We also support a number of global clients with their US-based
          Amazon Connect contact centres.
        </p>
      </div>
    </VideoBlock>
    <section>
      <div className="centre">
        <h4>
          The power of Amazon Connect & SmartAgent will truly reimagine your
          contact centre,{" "}
          <span className="highlight">delivering the following benefits:</span>
        </h4>
      </div>
    </section>
    <Section image={satisfaction} noparagraph padded>
      <h2>
        Customer <span className="highlight">satisfaction.</span>
      </h2>
      <hr />
      <p>
        Reduced queuing and call times with quicker and more relevant answers.
        Ability to talk on the customer’s preferred channel, in their language.
      </p>
    </Section>
    <Section reverse image={agentSatisfaction} noparagraph padded>
      <h2>
        Agent <span className="highlight">happiness.</span>
      </h2>
      <hr />
      <p>
        SmartAgent app specifically designed for agents, allowing the removal of
        repetitive, mundane tasks. Enables increased contact handling, from
        anywhere.
      </p>
    </Section>
    <Section image={saving} noparagraph padded>
      <h2>
        Reduced <span className="highlight">costs.</span>
      </h2>
      <hr />
      <p>
        Pay as you use contact centre model with no licence fees. Achieve lower
        average handle (AHT) times, deflection and quicker agent onboarding.
      </p>
    </Section>

    <section
      className="section section-padding"
      style={{ backgroundImage: `url(${peopleBg})` }}
    >
      <div className="centre">
        <div className="flex flex--responsive">
          <div>
            <h2>
              Migrating from on-premise? Not sure where to start?{" "}
              <span className="highlight">
                Here’s how we did it for First Group.
              </span>
            </h2>
            <Link className="button" to="/clients/firstgroup">
              Explore
            </Link>
          </div>
          <div className="flex__item">
            <img src={firstLogo} alt="first" width="200" />
          </div>
        </div>
      </div>
    </section>
    <section className="section-padding-top section--center">
      <div className="centre">
        <h2>
          Mission Labs + <span className="highlight">Amazon Connect.</span>
        </h2>
        <hr />
      </div>
    </section>
    <Section image={migrateScale} noparagraph padded>
      <h2>
        Migrate & <span className="highlight">scale.</span>
      </h2>
      <hr />
      <p>
        Amazon Connect is a globally accessible and highly scalable contact
        centre solution. We specialise in AWS best-practice design, build and
        deployment of Amazon Connect, including native natural language
        processing, robotics and exchange of data with any external systems.
        Amazon Connect’s 100% cloud-based platform provides a pay for usage
        model, removing the need for large long-term licence fees, hardware
        capex and operating overhead.
      </p>
      <p>
        <a className="highlight" href="https://aws.amazon.com/connect/">
          Find out more about Amazon Connect
        </a>
      </p>
    </Section>
    <Section reverse image={integrationAutomation} noparagraph>
      <h2>
        Integrate & <span className="highlight">automate.</span>
      </h2>
      <hr />
      <p>
        We specialise in bespoke integration and offer a number of ready-made
        connectors with tools such as Salesforce, C4C, Calabrio, Aspect,
        ServiceNow, Zendesk and PowerBI and the ability to integrate Amazon
        Connect with virtually any API. Our team of digital customer experience
        specialists also use AWS AI services to drive more efficient customer
        experiences including Amazon Lex for natural language and Amazon Polly
        for voice responses. We build high performing automated customer
        journeys, omnichannel chatbots and consolidated reporting.
      </p>
      <p>
        <Link to="/solutions/contact-automation" className="highlight">
          Find out more about Automation here
        </Link>
      </p>
    </Section>
    <Section image={assistApp} noparagraph>
      <h2>
        Agent <span className="highlight">efficiency.</span>
      </h2>
      <hr />
      <p>
        We offer a full suite of proprietary contact centre and agent efficiency
        tools, including our omnichannel agent desktop which can run stand-alone
        or embedded directly within your existing CRM or single customer view
        tool. SmartAgent integrates with Amazon Connect and provides a single
        pane of glass for agents, supervisors, analysts and assessors, working
        hand-in-hand with AWS automation and your back-office systems to improve
        efficiency, customer experience and compliance.
      </p>
      <p>
        <Link className="highlight" to="/solutions/agent-efficiency">
          Read more about Agency Efficiency here
        </Link>
      </p>
    </Section>
    <section className="section inverse section-padding">
      <div className="centre col2 col2--vertical-center">
        <div>
          <img src={integrateAutomate} alt="integrate Automate" />
        </div>
        <div>
          <h2> System Architecture</h2>
          <hr />
          <p>
            We design and build to AWS best practices, providing a robust,
            secure and production-ready Amazon Connect implementation that is
            ready to scale.
          </p>
        </div>
      </div>
    </section>
  </Layout>
)

export default AmazonConnect
